import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Skeleton,
} from '@mui/material'
import { AutoCoderPipelineRecord } from '../../types/gotypes'

interface FailedRecordsListProps {
  records: AutoCoderPipelineRecord[]
  totalCount: number
  isLoading: boolean
}

const truncate = (text: string, maxLen: number) =>
  text.length > maxLen ? text.slice(0, maxLen) + '...' : text

const FailedRecordsList = ({ records, totalCount, isLoading }: FailedRecordsListProps) => {
  if (isLoading) {
    return (
      <>
        {[...Array(3)].map((_, i) => (
          <Skeleton key={i} variant="rectangular" height={40} sx={{ mb: 1 }} />
        ))}
      </>
    )
  }

  if (records.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No failed records found.
      </Typography>
    )
  }

  return (
    <>
      {totalCount > records.length && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          Showing {records.length} of {totalCount} failed records
        </Typography>
      )}
      <TableContainer sx={{ maxHeight: 400 }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600, width: 120 }}>Interview ID</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Source Text</TableCell>
              <TableCell sx={{ fontWeight: 600, width: 300 }}>Error</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {records.map((record) => (
              <TableRow key={record.id}>
                <TableCell>
                  <Typography variant="body2" fontFamily="monospace">
                    {record.interview_id}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2" color="text.secondary">
                    {truncate(record.data?.source_text || '', 100)}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2" color="error.main">
                    {record.error}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}

export default FailedRecordsList
